// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote_quote__wkj58","bg":"quote_bg__Kz0_h","bgImg":"quote_bgImg__cGDp0","bgGrid":"quote_bgGrid__Lmtkg","quoteBrand":"quote_quoteBrand__3pwMe"};